import { useMemo } from "react";
import type { Performer } from "@shared/schema";

export function useOnStagePerformers(performers: Performer[]) {
  // Memoize the filtered and sorted performers to prevent unnecessary re-renders
  const onStagePerformers = useMemo(() => 
    performers
      .filter((performer) => 
        performer.status === 'on_stage' || performer.status === 'pending_removal'
      )
      .sort((a, b) => a.name.localeCompare(b.name)),
    [performers]
  );

  return onStagePerformers;
}